import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  id: string | number;
  link: string;
  img: string;
  title: string;
  description: string;
};

const ArticlesPost = (props: Props) => {
  const { img, link, title, description } = props;
  return (
    <>
      <div className="post__content">
        <h3
          className="post__title"
          dangerouslySetInnerHTML={{ __html: title }}
        ></h3>
        <p className="post__text">{description}</p>
        <Link to={link} className="more news__more">
          Читать больше
          <svg className="more__icon">
            <use href="/img/sprite.svg#icons--arrow-right"></use>
          </svg>
        </Link>
      </div>
      <div className="post__images">
        <img src={img} alt="img" />
      </div>
    </>
  );
};

export default ArticlesPost;
